import React from 'react';
import Slider from 'react-slick';
import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';


export default function Carousel({rows = 2, slidesToShow = 2, slidesToScroll = 2, isInfinite = false, children }) {
  const settings = {
    dots: true,
    infinite: isInfinite,
    centerPadding: '10px',
    speed: 500,
    slidesToShow: slidesToShow,
    slidesToScroll: slidesToScroll,
    rows: rows,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
          rows: 1,
          dots: false,
        },
      },
      {
        breakpoint: 1024,
        settings: {
          slidesToShow: 2,
          slidesToScroll: 2,
        },
      }
    ]
  };

  return (
    <div className="relative mb-6">
      <Slider {...settings}>
        {children}
      </Slider>
    </div>
  );
} 